<template>
  <v-dialog
    v-model="show"
    width="400px"
  >
    <div class="dialog-container">
      <div class="dialog-header">
        <p>{{isMember?'Team Code':'Referral QRCode'}}</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="disableCode"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <p
          v-if="isMember"
          class="text-center">{{form.team_head_url}}</p>
        <div
          class="qrcode  center-box mg-t-15">
          <div
            ref="container"
            class="qr-box">
            <v-qrcode
              :url="isMember?form.team_head_url:form.promo_url"
              :option="{
                width : '216',
                height : '216',
              }">

            </v-qrcode>
            <div
              v-if="!isMember"
              class="qr_avatar">
              <img
                v-if="form.avatar_thumb_content"
                id="download-img"
                ref="img"
                :src="form.avatar_thumb_content">
              <template v-else>
                <img
                  v-if="form.identity==1"
                  src="@/assets/images/icon/Personal-icon.png">
                <img
                  v-else
                  src="@/assets/images/icon/Company-icon.png">
              </template>

            </div>
          </div>
        </div>
        <p class="text-center color-dark fw-600">{{display_code}}</p>
        <div class="btn-list flex-sb-center">
          <v-button
            gray
            @click="disableCode">Cancel</v-button>
          <v-button
            green
            @click="handleDown">Download</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>

import domtoimage from 'dom-to-image'
import VQrcode from '@/components/control/v-qrcode'
export default {
  components:{
    VQrcode
  },
  props:{
    value: {
      type: Boolean,
      default: false
    },
    isMember: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: ()=>({})
    }
  },
  data () {
    return {
      show: false,
      qrcode:null,
      img:'https://holdcover.s3.ap-east-1.amazonaws.com/images/currencies/BTC.png'
    }
  },
  computed:{
    display_code(){
      let {code, team_head_code} = this.form||{}
      return (this.isMember ? team_head_code : code)||''
    }
  },
  watch: {
    value:{
      immediate:true,
      handler(val){
        this.show = val
        if(val){
          // this.convertImageToBase64(this.img).then((base64)=>{
          //   console.log('base64----',base64)
          // }).catch(err=>{
          //   console.log('base64---err-',err)
          // })
        }
      }
    },
  },
  methods: {
    convertImageToBase64(imageUrl) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const img = new Image()

        img.crossOrigin = 'Anonymous'
        img.onload = function() {
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0, img.width, img.height)

          try {
            const dataURL = canvas.toDataURL('image/png')
            resolve(dataURL)
          } catch (error) {
            reject(error)
          }
        }

        img.onerror = function(error) {
          reject(error)
        }

        img.src = imageUrl
      })
    },
    handleDown() {
      const container = this.$refs['container']
      domtoimage.toPng(container)
        .then((dataUrl) => {
          const link = document.createElement('a')
          link.href = dataUrl
          link.download = 'qrcode.png' // 下载的图片文件名
          link.click()
        })
        .catch((error) => {
          console.error('转换为图片时出现错误:', error)
        })
    },
    disableCode(){
      this.show = false
      this.$emit('input', this.show)
    },
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 25px 15px 25px;
    .qrcode{
      position: relative;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      .qr-box{
        padding: 15px;
        background: #fff;
        position: relative;
        display: flex;
        justify-content: center;
      }
      .qr_avatar{
        display: flex;
        justify-content: center;
        width: 58px;
        height: 58px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border: 4px solid #fff;
        background-color: #fff;
        border-radius: 50%;
        overflow: hidden;
        z-index: 2;
      }
    }
    .info{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      .link{
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 10px;
      }
      .blue{
        color: #0366D6;
      }
    }
    .btn-list{
      margin-top: 20px;
      text-align: right;
      .red{
        color: #CB2431;
      }
    }
  }
}
</style>
